import { render, staticRenderFns } from "./CategoryBox.vue?vue&type=template&id=a5a1bfe4&scoped=true"
import script from "./CategoryBox.vue?vue&type=script&lang=js"
export * from "./CategoryBox.vue?vue&type=script&lang=js"
import style0 from "./CategoryBox.vue?vue&type=style&index=0&id=a5a1bfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a1bfe4",
  null
  
)

export default component.exports